<template>
    <div class="course-list-page">
        <div class="course-list-top-bar">
            <!-- 1、顶部菜单栏 -->
            <div class="course-title-bar course-list-title-bar dsp-flex">
                <div class="bg1"></div><div class="bg2"></div>
                <div class="title-side title-yellow">
                    <span class="title-back discuss-title-back" @click="clickBack">
                        <i class="iconfont icon-xiangzuo"></i>
                    </span>
                </div>
                <div class="title-middle">
                    <span>课程中心</span>
                    <!-- <div class="sub-title">零基础科学入门不迷信</div> -->
                </div>
            </div>
            <!-- 2、顶部「我的课程学习记录」 -->
            <div class="course-list-learning-record" @click="clickCourseRecord"><span>我的课程学习记录</span></div>
        </div>
        <!-- 3、课程列表 -->
        <div class="course-list-content">
            <div class="course-list">
                <course-list-item :courseData="itemData" v-for="itemData in courseList" :key="itemData.id"></course-list-item>
            </div>
        </div>
        <div class="course-list-bottom">
            <p>更多课程，不定期更新，敬请期待！</p>
        </div>
    </div>
</template>

<script>
import CourseListItem from '../../components/course/CourseListItem.vue'
import { MIX } from '../../modules/utils';
export default {
    name: 'CourseList',
    components: { CourseListItem },
    computed: {
        courseList() {
            return this.$store.state.course.courseList;
        }
    },
    data() {
        return {
        }
    },
    mounted: function() {
        setTimeout(() => {
            console.log('initCourseList-----', this.$store.state.userData);
            this.$store.dispatch('course/initCourseList', {
                userVip: this.$store.state.userData ? this.$store.state.userData.info.vip : 0
            });
            let params = this.$router.history.current.params;
            this.$store.state.course.courseListPageFrom = params.from;
            window.scrollTo(0, 0);
            console.log('CourseList------', params.from)
            if(params.from == 'collate') {
                MIX.trackPageViewed('CourseCenterPage', 'home_banner_course');
            }else if(params.from == 'my') {
                MIX.trackPageViewed('CourseCenterPage', 'tab_me_course');
            }
        }, 20);
    },
    methods: {
        clickBack() {
            let from = this.$store.state.course.courseListPageFrom;
            if(from) {
                this.$router.replace('/'+from);
            }else {
                this.$router.replace('/collate');
            }
        },
        clickCourseRecord() {
            this.$router.replace('/courserecord');
        }
    }
}
</script>
